import { EYE_EXTERIOR_IMAGES, FUNDUS_IMAGES } from 'store/examinations';

export const mediaLabels = {
  [EYE_EXTERIOR_IMAGES]: 'Vorderes Auge',
  [FUNDUS_IMAGES]: 'Augenhintergrund',
};
